"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupListSink = void 0;
const icons_1 = require("client/components/icons");
const list_1 = require("client/components/list");
const checkbox_1 = require("client/components/ui/checkbox");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const react_1 = require("react");
const React = require("react");
const ReactCSSTransitionGroup = require("react-addons-css-transition-group");
require("./group-list.less");
let GroupListSink = class GroupListSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.checked = false;
        this.checkedBoxes = {};
        this.showChildren = false;
        this.renderGroupListRow = (row, index) => (React.createElement("div", { key: index },
            React.createElement("div", { className: "list-component__row parent-row", onClick: () => {
                    this.showChildren = !this.showChildren;
                } },
                React.createElement(checkbox_1.UiCheckbox, { checked: this.checked, fill: "#52e271", onChange: () => {
                        this.checked = !this.checked;
                        this.showChildren = this.checked ? true : this.showChildren;
                        row.children.forEach(child => (this.checkedBoxes[child.id] = this.checked));
                    } }),
                React.createElement("div", { className: "parent-row__name" }, "LIDOCAINE"),
                React.createElement("div", { className: "parent-row__column" },
                    React.createElement("label", null, "Count"),
                    "4"),
                React.createElement("div", { className: "parent-row__column" },
                    React.createElement("label", null, "Ordered"),
                    "102,267,017"),
                React.createElement("div", { className: "parent-row__column" },
                    React.createElement("label", null, "Max Profit"),
                    "28%"),
                React.createElement("div", { className: "parent-row__column parent-row__icon" },
                    React.createElement(icons_1.Chevron, { direction: this.showChildren ? "up" : "down" }))),
            React.createElement(ReactCSSTransitionGroup, { transitionName: "list", transitionEnterTimeout: 300, transitionLeaveTimeout: 100 }, this.showChildren && this.renderChildren(row.children))));
    }
    renderChildren(children) {
        return children.map((child, index) => (React.createElement("div", { className: "list-component__row", key: index },
            React.createElement(checkbox_1.UiCheckbox, { checked: this.checkedBoxes[child.id], fill: "#52e271", onChange: () => {
                    this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                        [child.id]: !this.checkedBoxes[child.id]
                    });
                } }),
            React.createElement("div", { className: "list-component__column--profile profile" },
                React.createElement("div", { className: "label" }, child.displayName),
                React.createElement("div", { className: "value" },
                    React.createElement("a", { href: "" }, child.email))),
            React.createElement("div", { className: "list-component__column workspace" },
                React.createElement("div", { className: "label" }, "Workspace"),
                React.createElement("div", { className: "value" }, child.workspace)),
            React.createElement("div", { className: "list-component__column site" },
                React.createElement("div", { className: "label" }, "Pharmacy"),
                React.createElement("div", { className: "value" }, child.site)),
            React.createElement("div", { className: "list-component__column group" },
                React.createElement("div", { className: "label" }, "Group"),
                React.createElement("div", { className: "value" }, child.group)),
            React.createElement("div", { className: "list-component__column--actions" }))));
    }
    render() {
        const data = [
            {
                name: "Lidocane",
                count: 4,
                ordered: "102,267,017",
                profit: "28%",
                children: [
                    {
                        id: 4,
                        displayName: "Someone",
                        email: "example@example.com",
                        group: "Group one",
                        site: "example.com",
                        workspace: "workspace"
                    }
                ]
            }
        ];
        return (React.createElement("div", { className: "list" },
            React.createElement("h2", null, "List W/ Parent"),
            React.createElement(list_1.List, { data: data, renderRow: this.renderGroupListRow })));
    }
};
__decorate([
    mobx_1.observable
], GroupListSink.prototype, "checked", void 0);
__decorate([
    mobx_1.observable
], GroupListSink.prototype, "checkedBoxes", void 0);
__decorate([
    mobx_1.observable
], GroupListSink.prototype, "showChildren", void 0);
GroupListSink = __decorate([
    mobx_react_1.observer
], GroupListSink);
exports.GroupListSink = GroupListSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/group-list/group-list.tsx
// module id = 3632
// module chunks = 0